import React from 'react';
import { useParams } from 'react-router-dom';
import { useIsAdmin, useIsEmployee } from '@/utils/auth/roleChecker';
import useTenantState from '@/states/tenant.state';
import { AccessDenied } from '@/pages/others/AccessDenied';

type AdminRoleGuardProps = {
  children: React.ReactNode;
};

export const AdminRoleGuard: React.FC<AdminRoleGuardProps> = ({ children }) => {
  const isAdmin = useIsAdmin();
  const isEmployee = useIsEmployee();
  const { currentTenant } = useTenantState();
  const { tenant_id } = useParams();

  if (isAdmin || isEmployee) {
    return <>{children}</>;
  }

  if (tenant_id && !isAdmin && !isEmployee) {
    console.warn(
      `User does not have admin or employee role in tenant "${currentTenant?.name || tenant_id}". Access denied.`,
    );
    return <AccessDenied />;
  }

  return null;
};
